// @noflow
import { heightRatios } from './constants';
import { memoize } from 'lodash/fp';

const MIN_HEIGHT_RATIO = 0.2; // When a day with no events is selected, it will use 20% of the height
const MAX_HEIGHT_RATIO = 0.7; // When a day with 6 events is selected, it will use 70% of the height
const MAX_EVENTS_IN_DAY = 6;
const DAYS_IN_WEEK = 7;
export const getSelectedDayHeight = (height, numEventsInSelectedDay) => {
    // if a day is selected then define its height depending of the number of events it has
    const expectedSelectedDayHeight =
        height *
        (MIN_HEIGHT_RATIO + (MAX_HEIGHT_RATIO - MIN_HEIGHT_RATIO) * numEventsInSelectedDay / MAX_EVENTS_IN_DAY);
    // now check how hight can be the 6 other days
    const otherDayHeight = Math.floor((height - expectedSelectedDayHeight) / (DAYS_IN_WEEK - 1));
    return {
        otherDayHeight,
        // Because we are flooring the value above, it may have some unused pixels so instead of
        // just returning the expectedSelectedDayHeight we return the rest of the total height minus
        // the 6 other days height
        selectedDayHeight: height - otherDayHeight * (DAYS_IN_WEEK - 1)
    };
};

export const getControlPanelHeight = memoize(componentHeight =>
    Math.floor(componentHeight * heightRatios.CONTROL_PANEL)
);
export const getTimeAxisHeight = memoize(componentHeight => Math.floor(componentHeight * heightRatios.TIME_AXIS));
export const getWeekHeight = memoize(
    componentHeight => componentHeight - getControlPanelHeight(componentHeight) - getTimeAxisHeight(componentHeight)
);

export const getPopupSize = memoize(componentHeight => Math.floor(componentHeight * 0.5));
export const getPopupButtonHeight = memoize(componentHeight => Math.floor(getPopupSize(componentHeight) * 0.2));



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/utils.js